export enum Actions {
  Save,
  Draft,
  Cancel,
  Add,
  Edit,
  Delete,
  Send,
}
